<template>
	<div class="ReSelectCascadeArmanNB">		
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Название ЖК</span></label>
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Название ЖК"				
				filterable
				v-model="value.arman_gk_name_tr"
				@change="onComplex"		
				clearable

			>
				<el-option
					v-for="(el_opt, el_index) in masComplex"
					class="select-primary"
					:value="el_opt.id"
					:label="el_opt.name"
					:key="el_index"                    
				>
				</el-option>
			</el-select>
		</div>
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Корпус</span></label>
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Корпус"
				v-model="value.arman_gk_block"
				@change="onCorp"
			>
				<el-option
					v-for="(corp, el_index) in masCorpOpts"
					class="select-primary"
					:value="corp.id"
					:label="corp.name"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Секция</span></label>
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Секция"
				v-model="value.arman_gk_sections"
			>
				<el-option
					v-for="(sec, el_index) in masSectionOpts"
					class="select-primary"
					:value="sec.id"
					:label="sec.name"
					:key="el_index"                    
				>
				</el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReSelectCascade',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: Object,
			findId: {
				type: String,
				default: '',
			},
			required:{
				type: Boolean,
				default: false
			},
			
		},
		data () {
			return {
				ver: 1,	
				masComplex: [],  
				masCorpOpts: [],
				objCurComplexBloks: {},
				masSectionOpts:[],
			}
		},
		computed: {

		},
		methods: {
			async onComplex(gk,bForce=false){
				// console.log(arguments);
				if(!bForce){
					this.value.arman_gk_block = '';
				}
				this.masCorpOpts = [];
				this.masSectionOpts = [];
				const data = await this.LoadData(gk);
				if(data.success === true){
					if(data.data.length>0){
						this.masCorpOpts = data.data;
					}
				}
			},
			async onCorp(block){
				this.value.arman_gk_sections = '';
				this.masSectionOpts = [];
				const data = await this.LoadData(block);
				if(data.success === true){
					if(data.data.length>0){
						this.masSectionOpts = data.data;
					}
				}
			},
			async LoadData(parentId){
				return this.$GVO.ApiCall('GET',{obj:'cat', flt:{cat_name:'cat_arman_nb', parentId}})
			},
			GetComplexList(){
				this.LoadData()
				.then((objApi) => {		
					// console.log(objApi);		
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masComplex = objApi.data;
							if (this.value.arman_gk_name_tr != '') {
								this.onComplex(this.value.arman_gk_name_tr,true);
							}
						}					
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			},
			// cancalReadOnly(onOff) {
            //     this.$nextTick(() => {
            //         if (!onOff) {
            //             const {select} = this.$refs;
            //             const input = select.$el.querySelector('.el-input__inner');
            //             input.removeAttribute('readonly');
            //         }
            //     });
            // }
		},
		mounted() {
			this.GetComplexList();           
		}
	}
</script>
<style scoped>
.white-content .el-input input::placeholder {color:#222a42;} 
.white-content .form-options-group  >>> .el-input__inner::placeholder {color:#222a42;} 
</style>
